import script from "./VideoSerializer.vue?vue&type=script&setup=true&lang=ts"
export * from "./VideoSerializer.vue?vue&type=script&setup=true&lang=ts"

import "./VideoSerializer.vue?vue&type=style&index=0&id=d17a5ed4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d17a5ed4"]])

export default __exports__